import axios from 'axios';
import KeyStore from 'utils/KeyStore';

export default class ManheimService {
    async importVehicles(companyCode) {
        return this.postImport('import-inventory-from-manheim', companyCode);
    }

    async importInvoices(companyCode) {
        return this.postImport('import-invoice-from-manheim', companyCode);
    }

    async importAll(companyCode) {
        return this.postImport('import-from-manheim', companyCode);
    }

    async postImport(endpoint, companyCode) {
        const {
            REACT_APP_GRAPHQL_HTTP,
            REACT_APP_GRAPHQL_BI_SERVER_HTTP,
        } = process.env;

        const keyStore = new KeyStore();
        const sessionToken = keyStore.getToken();
        if (!sessionToken) {
            throw new Error('The session token is not available. Please sign in again.');
        }
        const configuredBaseUrl = REACT_APP_GRAPHQL_BI_SERVER_HTTP ?? REACT_APP_GRAPHQL_HTTP;
        if (!configuredBaseUrl) {
            throw new Error('REACT_APP_GRAPHQL_HTTP is not configured.');
        }

        const baseUrl = configuredBaseUrl.replace(/\/$/, '');

        return axios.post(
            `${baseUrl}/${endpoint}`,
            { companyCode },
            {
                headers: {
                    Authorization: `Bearer ${sessionToken.replace(/^Bearer\s+/i, '')}`,
                    'Content-Type': 'application/json',
                },
            },
        );
    }
}
